<template>
  <el-dialog
    :visible.sync="importVisiable"
    width="1000px"
    top="100px"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="import-dialog"
  >
    <template slot="title">
      <div class="flex align-items-center">
        <span class="font-20">选择导入工单</span>
        <div class="item-width ml">
          <mes-num-selector
            v-model="query.mfgid"
            placeholder="选择制号"
            :disabled="loading"
            @change="fetchData"
          />
        </div>
        <div class="item-width ml-sm">
          <f-search-input
            v-model="query.keyword"
            placeholder="搜索"
            :disabled="loading"
            @change="fetchData"
          />
        </div>
      </div>
    </template>

    <div class="mt-md" style="height: 100%">
      <vxe-table
        ref="xTable1"
        height="460"
        row-key
        show-overflow
        border="inner"
        v-loading="loading"
        :row-config="{ isCurrent: true, isHover: true }"
        :export-config="{}"
        :tooltip-config="{ showAll: true }"
        :checkbox-config="{ checkField: 'checked' }"
        @checkbox-change="handleCheckChange"
        @checkbox-all="handleCheckChange"
      >
        <vxe-column type="checkbox" width="60" class-name="check-new-style"></vxe-column>
        <vxe-column field="workorder_no" title="工单号" min-width="100"></vxe-column>

        <vxe-column title="部件编码/名称" min-width="200" show-overflow>
          <template #default="{ row }">
            <div class="text-muted">{{ row.material_no }}</div>
            <div class>{{ row.material_title }}</div>
          </template>
        </vxe-column>

        <vxe-column title="工序编码/名称" min-width="200" show-overflow="tooltip">
          <template #default="{ row }">
            <div class="text-muted">{{ row.process_no }}</div>
            <div class>{{ row.process_title }}</div>
          </template>
        </vxe-column>

        <template #empty>
          <div class="empty">
            <img class="image larger mt-lg" src="@/assets/empty.png" />
            <div class="font-md mb-hg">暂无数据</div>
            <div>
              <el-button @click="$router.push('/mes/create')" type="text">创建任务</el-button>
            </div>
          </div>
        </template>
      </vxe-table>
    </div>
    <div class="mt-md mb-md flex">
      <div class="bd mt-sm mr ml-sm flex align-items-center">
        <el-checkbox
          v-model="checkall"
          :true-label="1"
          :false-label="0"
          :indeterminate="checkall == -1"
        >
          <span class="mr-sm number">已选中 {{ multiSelection.length }} 个工作项</span>
        </el-checkbox>
      </div>
      <div
        class="ft flex align-items-end text-right mt-sm number"
        style="text-align:right;"
      >共 {{ tableData.length }} 条</div>
    </div>

    <div slot="footer" class="text-center">
      <el-button class="extend" @click="importVisiable = false">取消</el-button>
      <el-button
        :disabled="!multiSelection.length"
        type="primary"
        class="extend"
        @click="confirmImport"
      >确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { allPlanApi, imporMesApi } from "@/api/mes/planApi";
export default {
  name: "MesImport",
  components: {
    MesNumSelector: () => import("@/views/mes/components/MesNumSelector"),
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      multiSelection: [],
      tableData: [],
      query: {
        mfgid: null,
        keyword: "",
      },
    };
  },
  computed: {
    importVisiable: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
    checkall: {
      get() {
        return !this.multiSelection.length
          ? 0
          : this.multiSelection.length < this.tableData.length
          ? -1
          : 1;
      },
      async set(val) {
        await this.$refs.xTable1.setAllCheckboxRow(val && true);
        this.handleCheckChange();
      },
    },
  },

  async created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      try {
        let res = await allPlanApi(this.query);
        if (!res.errno) {
          this.tableData = res.data;
          this.multiSelection = [];
          this.$refs.xTable1.reloadData(this.tableData);
        }
      } finally {
        this.loading = false;
      }
      return true;
    },
    handleCheckChange() {
      let all = this.$refs.xTable1.getCheckboxRecords();
      this.multiSelection = all;
    },

    confirmImport() {
      let remain = this.tableData.filter((item) => !item.checked);
      let show = this.tableData.filter((item) => item.checked);
      let workorderids = show.map((item) => {
        return item.workorderid;
      });
      imporMesApi({ workorderids }).then((res) => {
        if (!res.errno) {
          this.$emit("submit", { remain, show });
          this.$message.success("导入成功！");
        } else {
          this.$message.error(res.message);
        }

        this.importVisiable = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.import-dialog {
  .item-width {
    width: 160px;
  }

  .vxe-column-style {
    padding: 8px 0;
  }

  /deep/ .el-dialog__body {
    padding-bottom: 0;
  }
}
</style>
